module.exports = __webpack_public_path__ + "img/1941f7a.jpg";